"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatScheduleDate = exports.formatLocalDateToSQL = exports.formatLocalDateToISO = exports.default = exports.ONE_DAY_IN_MILLISECONDS = void 0;

var _intl = _interopRequireDefault(require("intl"));

require("intl/locale-data/jsonp/en-GB");

// https://github.com/andyearnshaw/Intl.js#regexp-cache--restore
// https://gainsight.atlassian.net/browse/CLC-1335
if (_intl.default.__disableRegExpRestore) {
  _intl.default.__disableRegExpRestore();
}

var ONE_DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24;
exports.ONE_DAY_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS;

var formatDateInLocalTimezone = function formatDateInLocalTimezone(timestamp) {
  var showTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var format = {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  };

  if (showTime) {
    format.hour = '2-digit';
    format.minute = '2-digit';
  }

  return new _intl.default.DateTimeFormat('en-GB', format).format(timestamp * 1000);
};
/**
 * Format a date to ISO 8601 format in local timezone (not UTC)
 *
 * Note: Cannot use Intl.DateTimeFormat as it doesn't support ISO format.
 * Manual formatting with native Date methods is the standard approach.
 *
 * @param {Date} date - The date to format
 * @returns {string} ISO formatted date string in local time (e.g., "2024-03-15T14:30:45")
 *
 * @see toISOString() for UTC time version
 */


var formatLocalDateToISO = function formatLocalDateToISO(date) {
  var year = date.getFullYear();
  var month = String(date.getMonth() + 1).padStart(2, '0');
  var day = String(date.getDate()).padStart(2, '0');
  var hours = String(date.getHours()).padStart(2, '0');
  var minutes = String(date.getMinutes()).padStart(2, '0');
  var seconds = String(date.getSeconds()).padStart(2, '0');
  return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hours, ":").concat(minutes, ":").concat(seconds);
};
/**
 * Format a date to "YYYY-MM-DD HH:mm:ss" format in local timezone
 *
 * Note: Cannot use Intl.DateTimeFormat as it doesn't support this exact format.
 * Manual formatting with native Date methods is the standard approach.
 *
 * @param {Date} date - The date to format
 * @returns {string} SQL-style datetime string in local time (e.g., "2024-03-15 14:30:45")
 */


exports.formatLocalDateToISO = formatLocalDateToISO;

var formatLocalDateToSQL = function formatLocalDateToSQL(date) {
  var year = date.getFullYear();
  var month = String(date.getMonth() + 1).padStart(2, '0');
  var day = String(date.getDate()).padStart(2, '0');
  var hours = String(date.getHours()).padStart(2, '0');
  var minutes = String(date.getMinutes()).padStart(2, '0');
  var seconds = String(date.getSeconds()).padStart(2, '0');
  return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
};
/**
 * Format a date to readable schedule format with locale-aware day/month names
 * @param {Date} date - The date to format
 * @param {string} locale - The locale to use (default: 'en-GB')
 * @returns {string} Formatted date string (e.g., "Mon 15 March 2024, 14:30")
 */


exports.formatLocalDateToSQL = formatLocalDateToSQL;

var formatScheduleDate = function formatScheduleDate(date) {
  var _parts$find, _parts$find2, _parts$find3, _parts$find4, _parts$find5, _parts$find6, _day;

  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-GB';
  // Use native globalThis.Intl instead of the polyfilled Intl to avoid month: 'long' issues
  var DateTimeFormat = typeof globalThis !== 'undefined' && globalThis.Intl ? globalThis.Intl.DateTimeFormat : _intl.default.DateTimeFormat;
  var parts = new DateTimeFormat(locale, {
    weekday: 'short',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).formatToParts(date);
  var weekday = (_parts$find = parts.find(function (p) {
    return p.type === 'weekday';
  })) === null || _parts$find === void 0 ? void 0 : _parts$find.value;
  var day = (_parts$find2 = parts.find(function (p) {
    return p.type === 'day';
  })) === null || _parts$find2 === void 0 ? void 0 : _parts$find2.value;
  var month = (_parts$find3 = parts.find(function (p) {
    return p.type === 'month';
  })) === null || _parts$find3 === void 0 ? void 0 : _parts$find3.value;
  var year = (_parts$find4 = parts.find(function (p) {
    return p.type === 'year';
  })) === null || _parts$find4 === void 0 ? void 0 : _parts$find4.value;
  var hour = (_parts$find5 = parts.find(function (p) {
    return p.type === 'hour';
  })) === null || _parts$find5 === void 0 ? void 0 : _parts$find5.value;
  var minute = (_parts$find6 = parts.find(function (p) {
    return p.type === 'minute';
  })) === null || _parts$find6 === void 0 ? void 0 : _parts$find6.value; // Ensure day is 2-digit padded (some locales/browsers may not respect '2-digit' option)

  day = (_day = day) === null || _day === void 0 ? void 0 : _day.padStart(2, '0');
  return "".concat(weekday, " ").concat(day, " ").concat(month, " ").concat(year, ", ").concat(hour, ":").concat(minute);
};

exports.formatScheduleDate = formatScheduleDate;
var _default = formatDateInLocalTimezone;
exports.default = _default;